import {AREA_UNITS, MEASUREMENT_SYSTEMS} from '@src/constants/measureUnits.ts';
import {useAppSelector} from '@src/hooks/redux.ts';

/**
 * Returns the user's preferred area unit (e.g. 'square-kilometers',
 * 'square-miles') based on the current measurement system, falling back to
 * square kilometers when no preference is stored. Pair with `formatArea` and
 * `UNIT_SYMBOLS` to render area values in the user's units.
 */
export const useAreaUnit = () =>
  useAppSelector(state =>
    state.settings.measurementSystem === MEASUREMENT_SYSTEMS.metric
      ? state.settings.areaUnitsMetric
      : state.settings.areaUnitsUSC,
  ) || AREA_UNITS[MEASUREMENT_SYSTEMS.metric].km2;

export default useAreaUnit;
